import Router from '../../common/components/router';
import RssFeeds from './rssFeeds';

class Router3 extends Router {
  constructor() {
    super(...arguments);
    this.RssFeeds = RssFeeds;
    this.imgParams = 'rs=w:200';
  }
}

export default Router3;
